import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import { cn } from '../../utils/cn';

type CardProps<T extends ElementType> = {
  as?: T;
  className?: string;
  children: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'className' | 'children'>;

export function Card<T extends ElementType = 'div'>({ as, className, children, ...props }: CardProps<T>) {
  const Component = as || 'div';
  return (
    <Component className={cn('bitmiyo-card bg-surface', className)} {...props}>
      {children}
    </Component>
  );
}
